export default __webpack_public_path__ + "static/media/phone_blue_icon.d8d3c9ea.svg";